import { render, staticRenderFns } from "./SvnAuthorization.vue?vue&type=template&id=abe1846a&scoped=true&"
import script from "./SvnAuthorization.vue?vue&type=script&lang=js&"
export * from "./SvnAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./SvnAuthorization.vue?vue&type=style&index=0&id=abe1846a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe1846a",
  null
  
)

export default component.exports